export const TaskAlertsWarning =
	'The number of records that have warnings/errors, the total number warnings/errors may be higher.';
